import React, { useContext, useEffect, useState } from 'react'
import { getI18nText } from '../../services/i18nService'
import {
  buildBrochureButtonInteractionEvent,
  publishBrochureButtonInteractionEvent,
  buildCADButtonInteractionEvent,
  publishCADButtonInteractionEvent,
  buildDatasheetButtonInteractionEvent,
  publishDatasheetButtonInteractionEvent,
  buildInstallationGuideButtonInteractionEvent,
  publishInstallationGuideButtonInteractionEvent,
} from '../../services/dataLayerService'
import { extractDomain } from '../../services/urlService'
import { findParentElementA } from '../../services/domService'
import DataLayerContext from '../../contexts/dataLayerContext'

const Downloads = ({ microcopy, data }) => {
  const { eventApi } = useContext(DataLayerContext)
  const [eventModelToPublish, setEventModelToPublish] = useState()
  const [cadUrl, setCadUrl] = useState()
  const [cadFileStepUrl, setCadFileStepUrl] = useState()
  const [broucherUrl, setBroucherUrl] = useState()
  const [technicalSpecsUrl, setTechnicalSpecsUrl] = useState()
  const [softwareUrl, setSoftwareUrl] = useState()
  const [
    installationAndMaintenanceInstructionspPdfUrl,
    setInstallationAndMaintenanceInstructionspPdfUrl,
  ] = useState()

  useEffect(() => {
    if (eventApi && eventModelToPublish) {
      if (eventModelToPublish.eventId === 'Brochure') {
        publishBrochureButtonInteractionEvent(eventApi, eventModelToPublish.eventModel)
      } else if (eventModelToPublish.eventId === 'CAD') {
        publishCADButtonInteractionEvent(eventApi, eventModelToPublish.eventModel)
      } else if (eventModelToPublish.eventId === 'Datasheet') {
        publishDatasheetButtonInteractionEvent(eventApi, eventModelToPublish.eventModel)
      } else if (eventModelToPublish.eventId === 'InstallationGuide') {
        publishInstallationGuideButtonInteractionEvent(eventApi, eventModelToPublish.eventModel)
      }
    }
  }, [eventApi, eventModelToPublish])

  useEffect(() => {
    if (
      data.pimData &&
      (data.pimData.cadenas_catalogue_path ||
        data.pimData.brochure ||
        data.pimData.technicalspecs ||
        data.pimData.software ||
        data.pimData.installationandmaintenanceinstructionspdf ||
        data.pimData.cadfilestep)
    ) {
      let myUrl = null
      if (data.pimData.cadenas_catalogue_path) {
        myUrl = `https://norgren-embedded.partcommunity.com?info=imi_precision${data.pimData.cadenas_catalogue_path}&varset=`
        if (data.pimData.varset) {
          myUrl = myUrl + `${data.pimData.varset}`
        }
        myUrl = myUrl + `&partFixed=false`
      }
      setCadUrl(myUrl)

      myUrl = null
      if (data.pimData.cadfilestep) {
        myUrl = 'https://cdn.norgren.com/cad-step/' + data.pimData.cadfilestep
      }
      setCadFileStepUrl(myUrl)

      myUrl = null
      if (data.pimData.brochure) {
        myUrl = 'https://cdn.norgren.com/pdf/' + data.pimData.brochure
      }
      setBroucherUrl(myUrl)

      myUrl = null
      if (data.pimData.technicalspecs) {
        myUrl = 'https://cdn.norgren.com/pdf/' + data.pimData.technicalspecs
      }
      setTechnicalSpecsUrl(myUrl)

      myUrl = null
      if (data.pimData.software) {
        myUrl = 'https://cdn.norgren.com/software/' + data.pimData.software
      }
      setSoftwareUrl(myUrl)

      myUrl = null
      if (data.pimData.installationandmaintenanceinstructionspdf) {
        myUrl =
          'https://cdn.norgren.com/pdf/' + data.pimData.installationandmaintenanceinstructionspdf
      }
      setInstallationAndMaintenanceInstructionspPdfUrl(myUrl)
    }
  }, [data.pimData])

  const handleClick = (e) => {
    let linkClasses = e.target.className
    let linkDomain = null
    let linkId = e.target.id
    let linkUrl = null
    let linkText = e.target.textContent

    var linkElement = findParentElementA(e.target, 0, 4)

    if (linkElement !== null) {
      linkUrl = linkElement.href
      linkDomain = extractDomain(linkUrl)
      linkId = linkElement.id
      linkClasses = linkElement.className
    }

    switch (linkId) {
      case 'cad-download':
        setEventModelToPublish({
          eventId: 'CAD',
          eventModel: buildCADButtonInteractionEvent(
            linkClasses,
            linkDomain,
            linkId,
            linkUrl,
            linkText
          ),
        })
        break
      case 'cadfile-download':
        setEventModelToPublish({
          eventId: 'CAD',
          eventModel: buildCADButtonInteractionEvent(
            linkClasses,
            linkDomain,
            linkId,
            linkUrl,
            linkText
          ),
        })
        break
      case 'brochure-download':
        setEventModelToPublish({
          eventId: 'Brochure',
          eventModel: buildBrochureButtonInteractionEvent(
            linkClasses,
            linkDomain,
            linkId,
            linkUrl,
            linkText
          ),
        })
        break
      case 'datasheet-download':
        setEventModelToPublish({
          eventId: 'Datasheet',
          eventModel: buildDatasheetButtonInteractionEvent(
            linkClasses,
            linkDomain,
            linkId,
            linkUrl,
            linkText
          ),
        })
        break
      case 'installationguide-download':
        setEventModelToPublish({
          eventId: 'InstallationGuide',
          eventModel: buildInstallationGuideButtonInteractionEvent(
            linkClasses,
            linkDomain,
            linkId,
            linkUrl,
            linkText
          ),
        })
        break
      default:
        break
    }
  }

  return (
    <table className="product-details__spec--downloads">
      <tbody>
        <tr>
          <td>
            <ul className="no-bullets d-flex flex-wrap">
              {cadUrl ? (
                <li>
                  <a
                    id="cad-download"
                    href={cadUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                    onClick={handleClick}
                  >
                    <i className="icon-CAD"></i>
                    <p>{getI18nText(microcopy, 'product.cad')}</p>
                  </a>
                </li>
              ) : null}
              {cadFileStepUrl ? (
                <li>
                  <a
                    id="cadfile-download"
                    href={cadFileStepUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                    onClick={handleClick}
                  >
                    <i className="icon-CAD"></i>
                    <p>
                      {getI18nText(microcopy, 'product.cad')}(
                      {getI18nText(microcopy, 'product.step')})
                    </p>
                  </a>
                </li>
              ) : null}
              {broucherUrl ? (
                <li>
                  <a
                    id="brochure-download"
                    href={broucherUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                    onClick={handleClick}
                  >
                    <i className="icon-Brochure"></i>
                    <p>
                      {getI18nText(microcopy, 'product.brochure')} (
                      {getI18nText(microcopy, 'product.pdf')})
                    </p>
                  </a>
                </li>
              ) : null}
              {technicalSpecsUrl ? (
                <li>
                  <a
                    id="datasheet-download"
                    href={technicalSpecsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                    onClick={handleClick}
                  >
                    <i className="icon-Brochure"></i>
                    <p>
                      {getI18nText(microcopy, 'product.datasheet')} (
                      {getI18nText(microcopy, 'product.pdf')})
                    </p>
                  </a>
                </li>
              ) : null}
              {softwareUrl ? (
                <li>
                  <a
                    href={softwareUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                  >
                    <i className="icon-Software"></i>
                    <p>{getI18nText(microcopy, 'product.software')}</p>
                  </a>
                </li>
              ) : null}
              {installationAndMaintenanceInstructionspPdfUrl ? (
                <li>
                  <a
                    id="installationguide-download"
                    href={installationAndMaintenanceInstructionspPdfUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-baseline"
                    onClick={handleClick}
                  >
                    <i className="icon-Brochure"></i>
                    <p>
                      {getI18nText(microcopy, 'product.installationguide')} (
                      {getI18nText(microcopy, 'product.pdf')})
                    </p>
                  </a>
                </li>
              ) : null}
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Downloads
